import Vue from 'vue';
import Vuex from 'vuex';
import event from './event';
import faq from './faq';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    event,
    faq,
  },
});

export default store;
